import axios from 'axios';

class UploadFilesService {
  async upload(file, onUploadProgress, dataID, url, refgen, tumor_type) {

    let formData = new FormData();
    formData.append("file", file);
    formData.append("id",dataID)
    formData.append("genome_version", refgen)
    formData.append("tumor_type", tumor_type)

    return await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });

  }

  async getFile(url) {
    await axios.get(url)
  }
}

export default new UploadFilesService();
